module.exports = __webpack_public_path__ + "img/PP实验台.dbb3fd1d.jpg";